import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { precacheImages } from 'redux/Precache/actions';
import { loadStaticPageContent } from 'redux/StaticPages/actions';
import { loadSuccessStories } from 'redux/SuccessStories/actions';
import { ssrHandler } from 'utils';

import SuccessStoryTemplate from './SuccessStoryTemplate';
import PanelInfo from './PanelInfo';

const PAGE_NAME = 'success-stories';

class SuccessStory extends PureComponent {
  constructor() {
    super();

    this.state = {
      open: false
    };
  }

  componentDidMount() {
    document.body.addEventListener('click', this.layoutClickHandler);
  }

  componentWillReceiveProps(nextProps) {
    const { location, page } = this.props;
    const pathnameChanged = location.pathname !== nextProps.location.pathname;
    const dataChanged = nextProps.page && nextProps.page.data && !page;

    if (pathnameChanged || dataChanged) {
      const story = this.getStoryByPathname(nextProps.location.pathname);
      this.props.precacheImages([story.background]);
    }
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.layoutClickHandler);
  }

  layoutClickHandler = (event) => {
    if (!this.state.open) {
      return;
    }

    if (!this.panel.contains(event.target)) {
      if (event) {
        event.preventDefault();
      }

      this.togglePanel();
    }
  };

  getStoryByPathname = (pathname) => {
    return this.props.page.data.find((story) => story.pathname === pathname);
  };

  togglePanel = (event) => {
    if (this.state.open) {
      document.documentElement.classList.remove('nav-open');
    } else {
      this.panel.childNodes[0].scrollTop = 0;
      document.documentElement.classList.add('nav-open');
    }

    this.setState({ open: !this.state.open });
  };

  render() {
    if (!this.props.page || !this.props.page.data) {
      return null;
    }

    const page = this.getStoryByPathname(this.props.location.pathname);
    const links = this.props.page.data.filter(({ name }) => name !== page.name);

    return (
      <div className="success-story-container">
        <SuccessStoryTemplate
          page={page}
          story={this.props.story}
          isMobile={this.props.isMobile}
          onOpenClick={this.togglePanel}
        />

        <div
          ref={(elem) => {
            this.panel = elem;
          }}
        >
          <PanelInfo
            open={this.state.open}
            story={this.props.story}
            links={links}
            program={page.program}
            onCloseClick={this.togglePanel}
          />
        </div>
      </div>
    );
  }
}

SuccessStory.propTypes = {
  name: PropTypes.string,
  page: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool.isRequired
  }),
  story: PropTypes.object,
  isMobile: PropTypes.bool,
  precacheImages: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => {
  let page = state.staticPages.items.find((page) => page.name === PAGE_NAME);
  const story = state.successStories.results.find(
    (item) => item.name === props.route.storyName
  );

  return {
    page,
    story: story || {},
    isMobile: state.app.width < 499
  };
};

const mapDispatchToProps = {
  precacheImages
};

function loadSuccessStoriesData(store, nextState, replace, callback) {
  const actions = [loadStaticPageContent(PAGE_NAME), loadSuccessStories()];

  ssrHandler(store.dispatch, actions, callback);
}

const createRoute = (store, pathname) => ({
  path: `/success-stories/${pathname}/`,
  component: connect(mapStateToProps, mapDispatchToProps)(SuccessStory),
  onEnter: loadSuccessStoriesData.bind(null, store),
  storyName: pathname
});

// Убрал ddener
const pages = [
  'nzrm',
  'lady_gentleman_city',
  'autoban',
  'naftatrans',
  'lambumiz',
  'kistochki'
];

export default (store) => pages.map(createRoute.bind(null, store));



// WEBPACK FOOTER //
// ./src/components/SuccessStory/index.js